"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAutoHeight = getAutoHeight;
var OFFSET = 300;
function getAutoHeight(totalCount, maxHeight, itemHeight) {
  var height = totalCount * itemHeight >= maxHeight ? maxHeight : totalCount * itemHeight;
  if (window && window.innerHeight > maxHeight + OFFSET) {
    return height;
  } else {
    if (window.innerHeight) {
      return window.innerHeight / 3;
    } else {
      return height;
    }
  }
}
//# sourceMappingURL=utils.js.map